import { render, staticRenderFns } from "./Acronym.vue?vue&type=template&id=244764e2&scoped=true&"
import script from "./Acronym.vue?vue&type=script&lang=js&"
export * from "./Acronym.vue?vue&type=script&lang=js&"
import style0 from "./Acronym.vue?vue&type=style&index=0&id=244764e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244764e2",
  null
  
)

export default component.exports